import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { sortCountries } from 'helpers/helpers';
import Background from 'components/Layout/Background';
import FormTextField from 'components/FormFields/FormTextField';
import FormSelectField from 'components/FormFields/FormSelectField';
import Message, { MessageVariant } from 'components/Message/Message';

import { ContractPhysicalData, ContractLegalData } from 'stores/workflowStores/workflowPersonalDataStore/model';

import { AccountMode } from 'enums';

interface Props {
  readOnly?: boolean;
  mode?: AccountMode;
  formikProps: FormikProps<ContractPhysicalData | ContractLegalData>;
  lockCountry?: boolean;
}

const TaxResidency = (props: Props) => {
  const { t } = useTranslation();
  const citizenshipOther = 'citizenship' in props.formikProps.values && props.formikProps.values.citizenship !== 'CZE';
  const taxresidencyOther = props.formikProps.values.taxResidency.country !== 'CZE';

  return (
    <Background inside>
      <Typography variant="h3">{t('contract_taxInfo')}</Typography>
      <Grid container>
        <Grid item xs={12} sm={6}>
          {props.readOnly || props.lockCountry ? (
            <FormTextField
              name="taxResidency.country"
              label={t('contract_taxInfo_taxResidency')}
              value={t(`country_${props.formikProps.values.taxResidency.country}`)}
              readOnly
            />
          ) : (
            <FormSelectField
              name="taxResidency.country"
              label={t('contract_taxInfo_taxResidency')}
              options={sortCountries(
                props.formikProps.values.options.taxResidencyCountry.map((code) => ({
                  value: code,
                  label: t(`country_${code}`),
                })),
              )}
            />
          )}
        </Grid>
      </Grid>

      {(taxresidencyOther || citizenshipOther) && props.formikProps.values.taxResidency.country !== '' && (
        <>
          <Grid container>
            <Grid item xs={12} />
          </Grid>
          <Typography variant="h3">
            {t(`contract_${citizenshipOther ? 'citizenship' : 'taxResidency'}OutsideCR`)}
          </Typography>
          <Grid container>
            <Grid item xs={6}>
              <FormTextField
                name="taxResidency.taxNumber.number"
                label={t('contract_taxInfo_number')}
                readOnly={props.readOnly}
                tooltipContent={
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('contract_taxInfo_number_tooltip', {
                        interpolation: { escapeValue: false },
                      }),
                    }}
                  />
                }
                maxLength={20}
              />
            </Grid>
          </Grid>
        </>
      )}
      {props.mode === AccountMode.LTIP && taxresidencyOther && (
        <Message
          id={`citizenship_notCZE`}
          message={t('contract_taxResidencyOutsideCR_LTIP')}
          variant={MessageVariant.LIGHT}
          permanent
        />
      )}
    </Background>
  );
};

export default TaxResidency;
